import { render, staticRenderFns } from "./dialog_tip.vue?vue&type=template&id=31cec68f&scoped=true"
import script from "./dialog_tip.vue?vue&type=script&lang=js"
export * from "./dialog_tip.vue?vue&type=script&lang=js"
import style0 from "./dialog_tip.vue?vue&type=style&index=0&id=31cec68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cec68f",
  null
  
)

export default component.exports